export const ExerciseLogsIcon = () => (
  <span style={{ display: 'inline-flex', marginLeft: '-3px' }}>
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6.5 6.5h11" />
      <path d="M6.5 17.5h11" />
      <path d="M3 12h18" />
      <circle cx="6.5" cy="6.5" r="1.5" />
      <circle cx="17.5" cy="6.5" r="1.5" />
      <circle cx="6.5" cy="17.5" r="1.5" />
      <circle cx="17.5" cy="17.5" r="1.5" />
      <rect x="2" y="4" width="2" height="16" />
      <rect x="20" y="4" width="2" height="16" />
    </svg>
  </span>
);
